export default (props, vars) => vars?.['useform3']?.['register']('future');
